import { AbgSxProps } from '@abg/typings';

export const containerStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  width: '100%',
};

export const additionalTextStyles: AbgSxProps = {
  textAlign: 'center',
  padding: '8px 0 12px',
};
